module.exports = __webpack_public_path__ + "img/comparison_exclusive-exp.0d97668e.jpg";